import React from 'react';

const TermsPage = () => {
  return (
    <div className="bg-[#0A0A14] text-[#F0EFF4] font-heading min-h-screen">
      <div className="max-w-3xl mx-auto px-6 py-20">
        {/* Header */}
        <h1 className="text-4xl md:text-5xl font-bold text-center mb-2">
          Terms &amp; Conditions
        </h1>
        <p className="text-sm text-[#F0EFF4]/40 text-center mb-16">
          Last updated: March 2026
        </p>

        <h2 className="text-2xl font-bold text-center mb-12 tracking-wide">
          ROOFCLAW SERVICE AGREEMENT
        </h2>

        {/* Section 1 */}
        <div className="border-b border-[#F0EFF4]/10 pb-8 mb-8">
          <h3 className="text-lg font-semibold mb-3">1. Parties</h3>
          <p className="text-[#F0EFF4]/70 leading-relaxed">
            This agreement is between RBP Consulting, Inc. (&ldquo;Company&rdquo;, operating as RoofClaw) and the purchaser (&ldquo;Client&rdquo;) identified at checkout.
          </p>
        </div>

        {/* Section 2 */}
        <div className="border-b border-[#F0EFF4]/10 pb-8 mb-8">
          <h3 className="text-lg font-semibold mb-3">2. Services</h3>
          <p className="text-[#F0EFF4]/70 leading-relaxed mb-3">
            Company agrees to provide:
          </p>
          <ul className="list-disc list-inside text-[#F0EFF4]/70 leading-relaxed space-y-1 ml-2">
            <li>One (1) pre-configured AI assistant deployment (&ldquo;RoofClaw&rdquo;)</li>
            <li>One (1) 1-hour pre-delivery consultation (discovery, identity design, integration mapping)</li>
            <li>Installation and configuration of up to three (3) API integrations</li>
            <li>One (1) 3-hour delivery and training session</li>
            <li>Ongoing access to Winning Wednesday group support webinars</li>
          </ul>
        </div>

        {/* Section 3 */}
        <div className="border-b border-[#F0EFF4]/10 pb-8 mb-8">
          <h3 className="text-lg font-semibold mb-3">3. Hardware</h3>
          <p className="text-[#F0EFF4]/70 leading-relaxed">
            Where hardware is included in the Client&rsquo;s package, Company will provide one (1) Apple Mac Mini or MacBook Air, pre-configured and security-hardened per the RoofClaw standard. Hardware ships to the Client&rsquo;s designated address. Client assumes risk upon delivery confirmation.
          </p>
        </div>

        {/* Section 3a */}
        <div className="border-b border-[#F0EFF4]/10 pb-8 mb-8">
          <h3 className="text-lg font-semibold mb-3">3a. Data Collection</h3>
          <p className="text-[#F0EFF4]/70 leading-relaxed mb-3">
            By using the RoofClaw website chatbot, you consent to the collection of information you provide (including name, email, company name, and business context) in accordance with our Privacy Policy. This data is used solely to evaluate fit and facilitate the RoofClaw onboarding process.
          </p>
          <p className="text-[#F0EFF4]/70 leading-relaxed">
            We may evaluate your fit using automated scoring based on your conversation. This assessment determines whether RoofClaw is offered to you.
          </p>
        </div>

        {/* Section 4 */}
        <div className="border-b border-[#F0EFF4]/10 pb-8 mb-8">
          <h3 className="text-lg font-semibold mb-3">4. Payment</h3>
          <p className="text-[#F0EFF4]/70 leading-relaxed">
            Total service fee: $10,000 USD (or $9,200 USD if an $800 AI Readiness Session has been previously completed and credited), invoiced in Canadian Dollars (CAD) at the prevailing exchange rate at time of purchase. Full payment is required to initiate scheduling.
          </p>
        </div>

        {/* Section 5 */}
        <div className="border-b border-[#F0EFF4]/10 pb-8 mb-8">
          <h3 className="text-lg font-semibold mb-3">5. Refund Policy</h3>
          <ul className="list-disc list-inside text-[#F0EFF4]/70 leading-relaxed space-y-1 ml-2">
            <li>Client may request a full refund within 36 hours of purchase, for any reason, provided delivery has not commenced.</li>
            <li>Where the Client&rsquo;s package included hardware purchased by Company: a $3,500 CAD refund will be issued (Company retains hardware cost difference).</li>
            <li>No refund is available after delivery of the 3-hour training session has commenced.</li>
          </ul>
        </div>

        {/* Section 6 */}
        <div className="border-b border-[#F0EFF4]/10 pb-8 mb-8">
          <h3 className="text-lg font-semibold mb-3">6. Confidentiality</h3>
          <p className="text-[#F0EFF4]/70 leading-relaxed">
            Client&rsquo;s data, credentials, and configuration details are stored on Client&rsquo;s dedicated hardware. Company retains no access to Client systems post-delivery. Company agrees not to disclose Client business information to third parties.
          </p>
        </div>

        {/* Section 7 */}
        <div className="border-b border-[#F0EFF4]/10 pb-8 mb-8">
          <h3 className="text-lg font-semibold mb-3">7. Limitation of Liability</h3>
          <p className="text-[#F0EFF4]/70 leading-relaxed">
            Company&rsquo;s total liability under this agreement shall not exceed the total fees paid by Client. Company is not responsible for third-party API availability, data loss, or interruptions in connected services (CRM, calendar, email providers).
          </p>
        </div>

        {/* Section 8 */}
        <div className="border-b border-[#F0EFF4]/10 pb-8 mb-8">
          <h3 className="text-lg font-semibold mb-3">8. Governing Law</h3>
          <p className="text-[#F0EFF4]/70 leading-relaxed">
            This agreement is governed by the laws of British Columbia, Canada. Disputes shall be resolved in the courts of British Columbia.
          </p>
        </div>

        {/* Section 9 */}
        <div className="pb-8 mb-12">
          <h3 className="text-lg font-semibold mb-3">9. Acceptance</h3>
          <p className="text-[#F0EFF4]/70 leading-relaxed">
            By completing payment, Client accepts these terms as a binding agreement.
          </p>
        </div>

        {/* Footer note */}
        <p className="text-xs text-[#F0EFF4]/30 text-center">
          Questions? Contact us at{' '}
          <a href="mailto:support@roofclaw.com" className="hover:underline">
            support@roofclaw.com
          </a>
        </p>
      </div>
    </div>
  );
};

export default TermsPage;
